import { useEffect, useState } from 'react';

/** The clock, ticking every `intervalMs` while `enabled`; countdowns read it. */
export function useNow(enabled = true, intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [enabled, intervalMs]);
  return now;
}
